<script>
    import {
        CardLayout,
        RichTextEditor,
    } from "../../../../Components/Common/index.svelte";

    export let patientEncounterDetails = {};

    // HELPER FUNCTIONS
</script>

<CardLayout title="Notes" headerClass="card-layout-empty-header" cardClass="!border-0 pl-4 pr-4"  enableCollapse={false}>
    <div class="flex flex-col flex-1 w-full gap-y-4">
        <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
            <!-- notes -->
            <div class="flex w-full px-2 col-span-6">
                <!-- <textarea
                    id="notes"
                    class="textarea w-full textarea-bordered"
                    rows="5"
                    autocomplete="off"
                    bind:value={patientEncounterDetails.notes}
                /> -->
                <RichTextEditor bind:content={patientEncounterDetails.notes} />
            </div>
        </div>
    </div>
</CardLayout>
